import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors, FontSizeInPx, Spacing } from "@snapchat/snap-design-system";

export const ApiContainer = styled.div`
    cursor: pointer;

    display: flex;
    align-items: center;

    padding: 0 ${Spacing.LG}px;

    background-color: ${Colors.WHITE};
    border-bottom: 1px solid ${Colors.Gray.V100};

    &:hover,
    &:focus {
        background-color: whitesmoke;
    }
`;

export const ApiDataContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const ApiClickableContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
`;

export const tableTextStyle = css`
    padding-right: ${Spacing.XS}px;
    font-size: ${FontSizeInPx.COMPACT}px;
    line-height: 18px;
    color: ${Colors.Black.V100};
`;

export const StatusSection = styled.div`
    padding-right: 5px;
`;

const circleButtonsStyle = `
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
    color: ${Colors.Black.V50};
`;

export const ActionSection = styled.div`
    > .sds-base-button.ant-btn.default {
        ${circleButtonsStyle};
    }

    > span .sds-base-button.ant-btn.default {
        ${circleButtonsStyle};
    }
`;
